<template>
  <div class="faq">
    <sc-placeholder name="jss-faq-item" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-FAQ',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object
    }
  }
};
</script>
